import React from 'react';
import { Icon } from '@highlight-ui/icon';
import classnames from 'classnames';

import SingleLineOptionLabel from './SingleLineOptionLabel';
import { SelectOptionLabelProps, SelectOption } from '../../../types';

import styles from './ColoredOptionLabel.module.scss';

function ColoredOptionLabel<T extends SelectOption>({
  option,
  highlightedText,
  selected,
  disabled,
}: SelectOptionLabelProps<T>) {
  return (
    <>
      <span
        className={classnames(styles.colorIcon, {
          [styles.coloredOption]: !option.disabled,
        })}
        style={
          !option.disabled
            ? ({
                '--colored-option': `${option.color}`,
              } as React.CSSProperties)
            : undefined
        }
      >
        <Icon name="circle" type="solid" size={12} />
      </span>

      <SingleLineOptionLabel
        highlightedText={highlightedText}
        option={option}
        selected={selected}
        disabled={disabled}
      />
    </>
  );
}

export default ColoredOptionLabel;
